import React, { ReactNode } from 'react';

import { IconButton } from '@mui/material';
import { Close } from './icons/close';
import { colors } from '../theme/palette';

type Props = {
  icon?: ReactNode;
  onClose: () => void;
};

export const DialogClose = ({ onClose, icon: icon = <Close /> }: Props) => (
  <IconButton
    onClick={onClose}
    sx={{
      position: 'absolute',
      zIndex: 10,
      right: 8,
      top: 8,
      color: colors.richBlack,
    }}
  >
    {icon}
  </IconButton>
);
